/**
 * Canonical absolute URLs for copy / share / “view public” (client + SSR).
 * Origin: {@link getSiteUrl} (`NEXT_PUBLIC_APP_URL` / `NEXT_PUBLIC_SITE_URL`, Vercel, or localhost).
 */

import { appendShareTokenQuery, getEventPublicUrl } from "@/lib/events/urls"
import { getPublicOriginForClientShell } from "@/lib/site-url"
import { EVENT_VISIBILITY_LINK_ONLY } from "@/lib/events/visibility"

export type ClientEventShareUrlEventLike = {
  id: string
  visibility?: string
  shareLinkDisabled?: boolean | null
  shareAccessToken?: string | null
}

export function resolveClientEventShareAbsoluteUrl(input: {
  eventId: string
  event: ClientEventShareUrlEventLike | null
  isUserHosting: boolean
  urlShareToken?: string | null
}): string {
  const { eventId, event, isUserHosting, urlShareToken } = input
  const eventLike = event ?? { id: eventId }
  const origin = getPublicOriginForClientShell()
  let url = getEventPublicUrl(eventLike, origin)
  const vis = event?.visibility
  if (
    vis === EVENT_VISIBILITY_LINK_ONLY &&
    event &&
    event.shareLinkDisabled !== true
  ) {
    const token =
      (isUserHosting && event.shareAccessToken?.trim()) ||
      urlShareToken?.trim() ||
      ""
    if (token) {
      url = appendShareTokenQuery(url, token)
    }
  }
  return url
}
